module.exports = __webpack_public_path__ + "static/media/712MeldrumStNW_2018-06-18_110.0cc10888.jpg";